export const PENDING_DOCUMENT = "pending_document";
export const REVIEWED_DOCUMENT = "reviewed_document";
